'use strict';

var chunkZMZBZQU6_js = require('./chunk-ZMZBZQU6.js');

// src/bartender.ts
var Bartender = class {
  id;
  profileId;
  name;
  password;
  status;
  controls;
  cashiers;
  deleted_at;
  created_at;
  updated_at;
  defaultCashier;
  constructor(bartender) {
    this.id = bartender.id, this.profileId = bartender.profileId, this.name = bartender.name, this.password = bartender.password, this.status = bartender.status, this.controls = bartender.controls, this.cashiers = bartender.cashiers ? bartender.cashiers.map((cashier) => new chunkZMZBZQU6_js.Cashier(cashier)) : [], this.deleted_at = bartender.deleted_at, this.created_at = bartender.created_at, this.updated_at = bartender.updated_at;
    this.defaultCashier = bartender.defaultCashier;
  }
};

exports.Bartender = Bartender;
